import { heart_report, IconGenWithLabel, temperature, vibration } from 'components/Icon'

export interface Step {
	title: string
	image: string
	alt?: string
	description?: string
	icon?: IconGenWithLabel
}

export const AutomaticTemp: Step = {
	title: 'Automatic temperature adjustments',
	description: 'The Pod makes adjustments throughout the night to keep you asleep & improve your sleep quality',
	alt: 'A bed powered by the Pod',
	image: 'https://eightsleep.imgix.net/temp_bed_steps.png?v=1690576881',
	icon: temperature,
}

export const Alarm: Step = {
	title: 'Vibration and thermal alarm',
	description: 'Wake up refreshed with customizable vibration & thermal alarm',
	alt: 'A modern bedroom with the Pod',
	image: 'https://eightsleep.imgix.net/1c84a2468d71aec84b14caf6de9579eb.jpg?v=1690490066',
	icon: vibration,
}

export const SleepInsights: Step = {
	title: 'Sleep and health insights',
	description: 'Each partner receives unique reports on metrics like sleep stages, heart rate, and HRV',
	alt: 'A man looking at his insights on his Eight Sleep app',
	image: 'https://eightsleep.imgix.net/man_hand_phone.jpg?v=1690489685',
	icon: heart_report,
}

export const coverSlides: Step[] = [
	{
		title: 'Add the Pod Cover to your mattress, like a fitted sheet',
		description:
			'The Pod Cover features an integrated 1-inch foam topper plus the Active Grid technology. The Active Grid facilitates the continuous absorption & removal of heat from your bed, helping you and your partner stay comfortably cool while also seamlessly tracking your sleep with imperceptible sensors.',
		image: 'https://eightsleep.imgix.net/pc3_2.jpg?v=1658749329',
		alt: 'Active Grid',
	},
	{
		title: 'Place the Hub near your bedside and connect it to Wi-Fi',
		description:
			'Water flows from the Hub to each side of the Active Grid to regulate the temperature of your Pod. The Hub also houses the connectivity to the Eight Sleep App, all powered by a new quad-core CPU exclusive to the Pod.',
		image: 'https://eightsleep.imgix.net/slide2.jpg?v=1654174428',
		alt: 'Water flow from the Hub',
	},
	{
		title: 'Create your profile in the Eight Sleep App (and one for your partner too)',
		description:
			'The Eight Sleep App allows you to view your sleep & health metrics, adjust your temperature, view health insights, and more. You can invite a partner to control their side of the Pod. ',
		image: 'https://eightsleep.imgix.net/slide3.jpg?v=1654174428',
	},
]

export const podSlides: Step[] = [
	{
		title: 'Start with our premium mattress base',
		description:
			'The premium 5-layer Pod Mattress includes ultimate back support, pressure point relief, and unmatched comfort that perfectly pairs with the Pod technology. Alternatively, with the Pod Cover, add the Pod technology to any bed.',
		image: 'https://eightsleep.imgix.net/slide0.jpg?v=1654174428',
		alt: 'Premium mattress base',
	},
	{
		title: 'Zip the Active Grid to your bed',
		description:
			'Our Active Grid facilitates the continuous absorption & removal of heat from your bed, and is able to reach temperatures between 55℉ and 110℉ on each bedside, helping you and your partner stay comfortable while also seamlessly tracking your sleep with undetectable sensors.',
		image: 'https://eightsleep.imgix.net/pc3_2.jpg?v=1658749329',
		alt: 'Active Grid',
	},
	{
		title: 'Place the Hub by your bed and connect it to Wi-Fi',
		description:
			'Water flows from the Hub to each side of the Active Grid to regulate the temperature of your Pod. The Hub also houses the connectivity to the Eight Sleep App, all powered by a new quad-core CPU exclusive to the Pod.',
		image: 'https://eightsleep.imgix.net/slide2.jpg?v=1654174428',
		alt: 'Water flow from the Hub',
	},
	{
		title: "Personalize your experience (and your partner's) with the Eight Sleep App",
		description:
			'The Eight Sleep App serves as a one-stop-shop to view your health & sleep metrics, adjust your temperature, view health insights, and more. You can invite a partner to control their side of the Pod. Just one 8+ membership will give you access for two accounts per Pod.',
		image: 'https://eightsleep.imgix.net/slide3.jpg?v=1654174428',
	},
]
